import styled from 'styled-components'

import { COLOR } from '@/shared/constant/color'

const CheckBoxFormWrap = styled.div`
  float: left;
  display: flex;
  gap: 22px;

  input[type='checkbox'] {
    -webkit-appearance: none;
    position: relative;
    width: 24px;
    height: 24px;
    cursor: pointer;
    margin: 0 10px 0 0;
    border: 1px solid ${COLOR.blueGray2};
    border-radius: 100px;
    background: #fff;
  }

  input[type='checkbox']:checked::before {
    content: '\\00a0';
    display: inline-block;
    width: 11px;
    height: 11px;
    margin: 6px;
    background: red;
    border-radius: 100px;
  }

  > section {
    margin-top: 15px;
    display: flex;
    height: 24px;

    > label {
      font-family: NotoSansRegular, sans-serif;
      cursor: pointer;
      font-size: 16px;
      color: ${COLOR.blueGray7};
    }
  }
`

const CustomCheckBox = styled.input``

export { CheckBoxFormWrap, CustomCheckBox }
